/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_SHOPPING_AREA } from "./actionTypes"
import { apiError, addShoppingAreaSuccess } from "./actions"

//Include Both Helper File with needed methods
import { addShoppingArea } from "../../../helpers/backend_helper"

function* add(action) {
  try {
    const response = yield call(addShoppingArea, action.payload.form)
    if (response == undefined) throw new Error("API error")
    if (!response.success) throw new Error("Error al guardar la zona comercial")
    yield put(addShoppingAreaSuccess(response))
  } catch (error) {
    yield put(apiError(error.message))
  }
}

function* shoppingAreaAddSaga() {
  yield takeEvery(ADD_SHOPPING_AREA, add)
}

export default shoppingAreaAddSaga
